<template>
  <div class="salaries-content-group-sdr-guide">
    <SalariesContentGroupHeader group-id="sdr-guide" />
    <SalariesContentBlock group-id="sdr-guide">
      <h3 slot="header" class="salaries-content-group-sdr-guide__header">
        Jan 2022:
        <br class="keep" />
        SDR Compensation
      </h3>
      <div slot="description2" class="salaries-content-group-sdr-guide__description2">
        The salaries collected from SDRs are split by Base Salary and OTE in USD. The median
        <br />
        pay of participants is presented as well as the 1st and 3rd quartile salaries.
        <br class="keep" />
        <br />
        Across 11,000+ sales teams, the
        <b>average compensation for SDRs rose by 35% in 2021</b>
        <br />
        and 11% in just Q4 alone.
      </div>
      <div slot="table" class="salaries-content-group-sdr-guide__table">
        <div class="salaries-content-group-sdr-guide__table-col">
          <Table6Svg alt="Average SDR Salaries: Base and OTE" class="salaries-content-group-sdr-guide__table-img" />
        </div>
      </div>
    </SalariesContentBlock>
    <SalariesContentBlock group-id="sdr-guide">
      <h3 slot="header" class="salaries-content-group-sdr-guide__header">SDR Salaries: By City</h3>
      <div slot="description2" class="salaries-content-group-sdr-guide__description2">
        The city with the highest median pay for SDRs is Austin, with OTE
        <br />
        above $100K+.
      </div>
      <div slot="table" class="salaries-content-group-sdr-guide__table">
        <div class="salaries-content-group-sdr-guide__table-col">
          <Table7Svg
            alt="Average SDR Salaries: Base and OTE By City location"
            class="salaries-content-group-sdr-guide__table-img"
          />
        </div>
      </div>
    </SalariesContentBlock>
    <SalariesContentBlock group-id="sdr-guide">
      <h3 slot="header" class="salaries-content-group-sdr-guide__header">
        SDR Salaries:
        <br class="keep" />
        By Years of Experience
      </h3>
      <div slot="description2" class="salaries-content-group-sdr-guide__description2">
        SDRs with 3+ years of experience can make on average $10K+ more than their peers with
        <br />
        2 years or less experience.
      </div>
      <div slot="table" class="salaries-content-group-sdr-guide__table">
        <div class="salaries-content-group-sdr-guide__table-col">
          <Table8Svg
            alt="Average SDR Salaries: Base and OTE By Years of Experience"
            class="salaries-content-group-sdr-guide__table-img"
          />
        </div>
      </div>
    </SalariesContentBlock>
  </div>
</template>

<script>
import SalariesContentGroupHeader from './SalariesContentGroupHeader.vue';
import SalariesContentBlock from './SalariesContentBlock.vue';
import Table6Svg from './images/table6.vue.svg';
import Table8Svg from './images/table8.vue.svg';

export default {
  name: 'SalariesContentGroupSdrGuide',
  components: {
    SalariesContentBlock,
    SalariesContentGroupHeader,
    Table6Svg,
    Table7Svg: () => import('@/components/Icon/Table7.vue'),
    Table8Svg,
  },
};
</script>

<style lang="scss" scoped>
.salaries-content-group-sdr-guide {
  &__header {
    background: linear-gradient(269.66deg, #676767 -81.31%, #282828 101.17%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 8px;
  }

  &__description2 {
    margin-bottom: 32px;
  }

  ::v-deep .salaries-content-group-header__title {
    font-size: 44px;

    @include mq('sm') {
      font-size: 56px;
    }
  }

  &__table {
    display: flex;
    justify-content: space-between;
  }

  &__table-col {
    &:first-child {
      flex-grow: 1;
      display: flex;
      justify-content: space-between;
    }

    & + &:last-child {
      margin-left: 71px;
      flex-shrink: 0;
      flex-basis: 361px;
    }
  }

  &__table-img {
    border-radius: 16px;
    overflow: hidden;
    filter: drop-shadow(0 34px 56px rgba(0, 0, 0, 0.12));
    width: 100%;
    height: auto;

    @include mq('sm') {
      width: auto;
    }
  }

  &__table-text-header {
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: -0.5px;
    margin-bottom: 8px;
    background: linear-gradient(87.2deg, #1b447f -9.58%, #5f86d1 104.83%), linear-gradient(0deg, #fff, #fff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &__table-text + &__table-text-header {
    margin-top: 32px;
  }

  &__table-text {
    font-size: 16px;
    line-height: 30px;
    color: #45454a;
  }
}
</style>
